import { getName, isNotDefined, type UserProfileData } from '@terros/common'
import { useNavigate } from '@tanstack/react-router'
import { useProfile, useTranslation } from '@front/model'

export type SidebarAccountActions = {
  user: UserProfileData | undefined
  userName: string
  openProfile: () => void
  openSettings: () => void
}

export const useSidebarAccountActions = ({
  sidebarUser,
  onNavigate,
}: {
  sidebarUser?: UserProfileData
  onNavigate?: VoidFunction
}): SidebarAccountActions => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { user: profileUser } = useProfile()
  const user = sidebarUser ?? profileUser
  const userName = user ? getName(user) : t('Account')

  const openProfile = (): void => {
    if (isNotDefined(user)) return
    navigate({ to: `/user/${user.userId}` })
    onNavigate?.()
  }

  const openSettings = (): void => {
    navigate({ to: '/settings' })
    onNavigate?.()
  }

  return { user, userName, openProfile, openSettings }
}
